import { apiClient } from './client';
import { Version, CreateVersionRequest, PaginatedResponse, GenerateUploadUrlRequest, GenerateUploadUrlResponse, InitiateMultipartUploadRequest, InitiateMultipartUploadResponse, CompleteMultipartUploadRequest } from '../types';
import axios from 'axios';

export const versionsApi = {
  getVersions: async (page = 1, limit = 10, appId?: number): Promise<PaginatedResponse<Version>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (appId) {
      params.append('app_id', appId.toString());
    }
    return apiClient.get(`/admin/versions?${params.toString()}`);
  },

  generateUploadUrl: async (request: GenerateUploadUrlRequest): Promise<GenerateUploadUrlResponse> => {
    return apiClient.post('/admin/upload/generate-url', request);
  },

  uploadFileToS3: async (uploadUrl: string, file: File, contentType: string, onProgress?: (progress: number) => void): Promise<void> => {
    await axios.put(uploadUrl, file, {
      headers: {
        'Content-Type': contentType,
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      },
    });
  },

  createVersion: async (version: CreateVersionRequest): Promise<Version> => {
    return apiClient.post('/admin/versions', version);
  },

  deleteVersion: async (appId: number, version: string): Promise<void> => {
    return apiClient.delete(`/admin/versions/${appId}/${version}`);
  },

  // Multipart upload APIs
  initiateMultipartUpload: async (request: InitiateMultipartUploadRequest): Promise<InitiateMultipartUploadResponse> => {
    return apiClient.post('/admin/upload/multipart/initiate', request);
  },

  uploadPartToS3: async (uploadUrl: string, partData: Blob, onProgress?: (progress: number) => void): Promise<string> => {
    const response = await axios.put(uploadUrl, partData, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      },
    });
    
    // Return ETag from response headers
    const etag = response.headers['etag'];
    if (!etag) {
      throw new Error('ETag not found in response headers');
    }
    return etag;
  },

  completeMultipartUpload: async (request: CompleteMultipartUploadRequest): Promise<void> => {
    return apiClient.post('/admin/upload/multipart/complete', request);
  },

  checkVersionDuplicate: async (version: string): Promise<{ is_duplicate: boolean; message: string }> => {
    return apiClient.post('/admin/versions/check-duplicate', { version });
  },
};
